import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';


@Injectable({
  providedIn: 'root'
})
export class JobService {

  private BASE_URL_SERVICE: string = environment.endpoint.apijob;

  constructor(
    private http: HttpClient) {
  }

  setJobapplicationStatus(idJob: number, jobApplicationId: number, jobApplicationStatus: number, _idUser, _idEmployer) {

    let req = {

      _id: jobApplicationId,
      _idJob: idJob,
      _idUser: _idUser,
      _idEmployer: _idEmployer,
      jobApplicationStatus: jobApplicationStatus
    };

    return this.http.post<any>(this.BASE_URL_SERVICE + 'setJobapplicationStatus/', req);
  }

  getJobapplicationCounter(idJob: number, _idUser, _idEmployer) {
    let req = {
      _idJob: idJob,
      _idUser: _idUser,
      _idEmployer: _idEmployer,
    };

    return this.http.post<any>(this.BASE_URL_SERVICE + 'getJobapplicationCounter/', req);
  }


  sendMessageByStatus(params: any) {

    var req = {
      _idJob: params._idJob,
      _idEmployer: params._idEmployer,
      _idUser: params._idUser,
      jobMessage: params.jobMessage,
      status: params.status,
    };

    return this.http.post<any>(this.BASE_URL_SERVICE + 'sendMessageByStatus/', req);
  }

  getApplicationsByEmployee(req: any) {

    return this.http.post(this.BASE_URL_SERVICE + 'applicationsByEmployee/', req);
  }

  closeAd(req: any) {
    return this.http.post(this.BASE_URL_SERVICE + 'closeAd/', req);
  }

  searchJobCategory(req: any) {
    return this.http.post(this.BASE_URL_SERVICE + 'searchJobCategory/', req);
  }

  searchJobCategoryLanding(req: any) {
    return this.http.post(this.BASE_URL_SERVICE + 'searchJobCategoryLanding/', req);
  }

  searchCategoryCount() {
    return this.http.post(this.BASE_URL_SERVICE + 'searchCategoryCount/', {});
  }

  searchOpenJobsEmployer(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'searchOpenJobsEmployer/', req);
  }

  getJobDetail(_id: string, _idEmployer: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'getJobDetail/', { _idJob: _id, _idEmployer: _idEmployer });
  }

  getJobAdvice(_idJob: any, category: string | undefined | null, _idUser: any) {

    const req = {
      _idJob: _idJob,
      _idUser: _idUser,
      category
    }

    return this.http.post<any>(this.BASE_URL_SERVICE + 'getJobAdvice/', req)
  }

  getJobAdviceEmployee(_idJob: any, _idUser: any) {


    let req = {
      _idJob: _idJob,
      _idUser: _idUser
    }

    return this.http.post<any>(this.BASE_URL_SERVICE + 'getJobAdviceEmployee/', req)
  }

  getEmployeeRecomendation(req: any) {

    return this.http.post<any>(this.BASE_URL_SERVICE + 'getEmployeeRecomendation/', req)
  }


  getEmployeeRecomendationSearch(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'getEmployeeRecomendationSearch/', req)
  }


  postJobNetwork(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'postJobNetwork/', req);
  }

  openJob(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'openJob/', req);
  }

  putJob(_id: any, req: any) {
    return this.http.put<any>(this.BASE_URL_SERVICE + `putJob/${_id}`, req);
  }

  applyJob(req) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'applyjob/', req);
  }

  jobAddressByEmployer(_idEmployer: number) {
    return this.http.post(this.BASE_URL_SERVICE + 'jobAddressByEmployer/', { _idEmployer: _idEmployer });
  }

  jobsByEmployerNetwork(req: any) {
    return this.http.post(this.BASE_URL_SERVICE + 'jobsByEmployerNetwork/', req);
  }

  applicantsJobSuggestion(req) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'applicantsJobSuggestion/', req);
  }

  getEmployeesByJob(_idjob: any) {

    var req = {
      _idJob: _idjob
    };

    return this.http.post<any>(this.BASE_URL_SERVICE + 'getEmployeesByJob/', req);
  }

  getJobActives(_idUser: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'jobsActive/', { _idUser });
  }

  sendJobInvitation(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'sendJobInvitation/', req);
  }

  sendPsychoInterview(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'sendPsychoInterview/', req);
  }

  validatePsychoInterview(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'validatePsychoInterview/', req);
  }


  askQuestion(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'askQuestion/', req);
  }

  likeQuestion(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'likeQuestion/', req);
  }

  setAnswerQuestion(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'setAnswerQuestion/', req);
  }

  deleteQuestion(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'deleteQuestion/', req);
  }

  getJobQuestion(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'getJobQuestion/', req);
  }

  rejectInvitation(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'rejectInvitation/', req);
  }

  getCertificate(_idJob: number) {
    return this.http.post(this.BASE_URL_SERVICE + 'jobCertificate/', { _idJob }, { reportProgress: true, observe: 'events', responseType: "blob" });
  }

  deleteApplication(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'deleteApplication/', req);
  }

}
